<template>
    <app-button
        color="positive"
        :icon="isSaving ? 'hourglass_empty' : 'done'"
        type="submit"
        :disable="isSaving"
        :label="label"
    />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    what: String, // Optional name of entity being saved
    isSaving: Boolean,
})

const label = computed(() => {
    if (props.isSaving) return trans('saving')
    return props.what
        ? trans('save_what', { what: props.what })
        : trans('save')
})
</script>
